(function (window, $, nn) {

  nn.handlers.init.IntializeStorage = function () {

    nn.globals.storage = new $.store();
  }

})(window, jQuery, nn);